import React,{useContext,useEffect,useState} from 'react';
import './Preloader.css';
import SimpleContext from '../context/SimpleContext';





const Preloader = ({type}) => {



    const context = useContext(SimpleContext);
    

   
    const bgColor= context.theme.backgroundColor
    const dot = {
        margin: "auto",
        color:bgColor,
        width:"60px",
        height:'40px',
        "--d":'radial-gradient(farthest-side,currentColor 90%,#0000)',
        background:"var(--d),var(--d),var(--d)",
        backgroundSize:'20px 20px',
        backgroundRepeat:'no-repeat',
        animation:' m 1s infinite alternate',
    }
              

    // let returner ={} ;

    // if(context.AppType==="appGallery"){

    //     returner = 

    // }elseif(){

    // }elseif(){

    // }

    return ( 


             <div style={{   width: "100%",
                height: '30px',
                // background-color: #fef8f8;
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-end',}}>
             {/* <img style={{width:"100%",maxWidth:"400px", height:"250px", marginTop:"30%"}} src="./images/animated_splash.gif" alt="ApiLogo" />  */}
              <div  className="dott" ></div>
               
             </div> 
      

     );
}
 
export default Preloader;